const BOT_UA =
  /HeadlessChrome|PhantomJS|SlimerJS|Puppeteer|Playwright|Selenium|Electron|crawl|spider|scrape/i;

// Case-sensitive so suffix crawlers match (Googlebot, bingbot, GPTBot,
// AhrefsBot) while all-caps device names like CUBOT do not.
const BOT_TOKEN = /[Bb]ot\b/;

/**
 * Every engine gives `new Error("x")` a configurable own `message`. Stealth
 * automation that spoofs its user agent and swaps in an `Error` wrapper pinning
 * `message` breaks axios, whose AxiosError constructor redefines it and throws
 * "Cannot redefine property: message" on every non-2xx response. A probe that
 * throws keeps the event: letting it escape would make Sentry's `beforeSend`
 * swap the user's error for an internal diagnostic.
 */
function hasPinnedErrorMessage(): boolean {
  try {
    const probe = new Error("probe");
    return (
      Object.getOwnPropertyDescriptor(probe, "message")?.configurable === false
    );
  } catch {
    return false;
  }
}

/**
 * Detects automated browsers (headless Chrome, scrapers, crawlers) so their
 * errors never reach Sentry. Bots load stale cached HTML referencing chunk
 * hashes that no longer exist, sit behind interception proxies that return
 * HTML for script requests, and generally produce errors no real user hits.
 */
export function isBotBrowser(
  userAgent: string = typeof navigator === "undefined"
    ? ""
    : navigator.userAgent,
  webdriver: boolean = typeof navigator === "undefined"
    ? false
    : navigator.webdriver === true,
): boolean {
  return (
    webdriver ||
    BOT_UA.test(userAgent) ||
    BOT_TOKEN.test(userAgent) ||
    hasPinnedErrorMessage()
  );
}
